module.exports = __webpack_public_path__ + "static/media/workshopIcon.35e5a166.svg";